import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullTimeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Group_5597",
	"data-name": "Group 5597",
	xmlns: "http://www.w3.org/2000/svg",
	width: 52.164,
	height: 52.164,
	viewBox: "0 0 52.164 52.164",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_5598",
		"data-name": "Group 5598",
		transform: "translate(0 0)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_8221",
			"data-name": "Path 8221",
			d: "M41.744,24.356a17.3,17.3,0,0,1,9.936,3.13V16.9a4.951,4.951,0,0,0-4.968-4.968H36.776V6.968A4.951,4.951,0,0,0,31.808,2H21.872A4.951,4.951,0,0,0,16.9,6.968v4.968H6.968A4.93,4.93,0,0,0,2.025,16.9L2,44.228A4.951,4.951,0,0,0,6.968,49.2H26.045a17.369,17.369,0,0,1,15.7-24.84ZM21.872,6.968h9.936v4.968H21.872Z",
			transform: "translate(-2 -2)"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_8222",
			"data-name": "Path 8222",
			d: "M25.42,13A12.42,12.42,0,1,0,37.84,25.42,12.425,12.425,0,0,0,25.42,13Zm4.1,18.257-5.341-5.341V17.968h2.484V24.9l4.6,4.6Z",
			transform: "translate(14.324 14.324)"
		})]
	})
});
export { SvgFullTimeIcon as ReactComponent };
